const getJobDesigns = (state) => state.designPro.jobDesigns.jobDesigns;
const getSelectedDesignId = (state) =>
  state.designPro.jobDesigns.selectedDesignId;

export default {
  getJobDesigns,
  getSelectedDesignId,
};
